export const defaultAuthority = {
  diandanguanli_f5ee7b35_e42a_4a94_a4ab_3aab6b58cb1e: [
    // 一项代表一个权限
    // {
    //   // tbId: 666,
    //   tbSlug: 'diandanguanli_f5ee7b35_e42a_4a94_a4ab_3aab6b58cb1e',
    //   authority: {
    //     // 权限含义：对于所有人来说，自己编辑自己创建的数据
    //     // 权限成员（这里的配置针对哪些人）
    //     // member 暂时没判断
    //     member: {
    //       type: 'all', // organize 所属组织，即同一组织下的可操作 all 所有人
    //       // orgIds: [], // 如果type是organize，则有一个组织id
    //     },
    //     // 管理范围
    //     range: 'self', // 自己创建的  （其他有全公司、同层级、下属的、自定义即视图配置的）

    //     // 操作权限
    //     operable: {
    //       actionTypes: ['editorConfig'], // 操作权限一样
    //     },
    //   },
    // },
    {
      tbSlug: 'diandanguanli_f5ee7b35_e42a_4a94_a4ab_3aab6b58cb1e',
      authority: {
        member: {
          type: 'all',
        },
        range: 'all',
        operable: {
          actionTypes: ['detailConfig'],
        },
      },
    },
  ],
  // 远洋这个也没确定好要不要从这里入手判断操作权限
  zhengcezhuantishujubiao_5777c254_8181_4abf_b3be_2ced909b645b: [
    // 一项代表一个权限
    {
      // tbId: 666,
      tbSlug: 'zhengcezhuantishujubiao_5777c254_8181_4abf_b3be_2ced909b645b',
      authority: {
        // 权限含义：对于所有人来说，自己编辑自己绑定点位的数据
        // 权限成员（这里的配置针对哪些人通过角色区分，超级管理员可操作所有数据、普通用户只能操作自己绑定的点位的数据）
        member: {
          type: 'all', // organize 所属组织，即同一组织下的可操作 all 所有人
          // orgIds: [], // 如果type是organize，则有一个组织id
        },
        superRole: [{ roleSlug: 'zdy_chaojiyonghu', range: 'all' }], // 有高级权限的角色
        // 管理范围
        range: 'selfBindArea', // 自己绑定的点位

        // 操作权限
        operable: {
          actionTypes: ['editorConfig'], // 操作权限一样
        },
      },
    },
  ],
  zhiyuanfuwudiandanpaidan_b2ebcec9_17ec_41b9_a193_c43c457add55: [
    // 一项代表一个权限
    {
      // tbId: 666,
      tbSlug: 'zhiyuanfuwudiandanpaidan_b2ebcec9_17ec_41b9_a193_c43c457add55',
      authority: {
        // 权限含义：对于所有人来说，自己编辑自己创建的数据
        // 权限成员（这里的配置针对哪些人）
        // member 暂时没判断
        member: {
          type: 'all', // organize 所属组织，即同一组织下的可操作 all 所有人
          // orgIds: [], // 如果type是organize，则有一个组织id
        },
        // 管理范围
        range: 'self', // 自己创建的  （其他有全公司、同层级、下属的、自定义即视图配置的）

        // 操作权限
        operable: {
          actionTypes: ['editorConfig'], // 操作权限一样
        },
      },
    },
    // {
    //   tbSlug: 'zhiyuanfuwudiandanpaidan_b2ebcec9_17ec_41b9_a193_c43c457add55',
    //   authority: {
    //     member: {
    //       type: 'all',
    //     },
    //     range: 'all',
    //     operable: {
    //       actionTypes: ['deleteConfig'],
    //     },
    //   },
    // },
  ],
}

// 需判断要创建默认视图的类型，目前写死list
export const createSjsAuthority = (appId, tbId, tbSlug) => {
  return defaultAuthority[tbSlug]
}

// 获取各表单操作权限
export const fetchTbOperationAuthorityConfig = (appId, tbId, tbSlug) => {
  // 目前只有石景山、远洋用到了，先写死
  return Promise.resolve(createSjsAuthority(appId, tbId, tbSlug))
}
